<template>
  <div>
    <!--<logo v-if="showLogo" :collapse="isCollapse" />-->
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        router>
        <el-menu-item index="/member/index">
          <svg-icon class-name="ico28" icon-class="account" />
          <span>账户总览</span>
        </el-menu-item>
        <el-menu-item index="/order/query">
          <svg-icon class-name="ico28" icon-class="query" />
          <span>订单查询</span>
        </el-menu-item>
        <el-menu-item index="/statistics/index">
          <svg-icon class-name="ico28" icon-class="statistics" />
          <span>订单统计</span>
        </el-menu-item>
        <el-menu-item index="/exportrecord">
          <svg-icon class-name="ico28" icon-class="record" />
          <span>导出记录</span>
        </el-menu-item>
        <el-menu-item index="/account/index">
          <svg-icon class-name="ico28" icon-class="info" />
          <span>账户信息</span>
        </el-menu-item>
        <!--<el-menu-item index="/apply/index">-->
          <!--<svg-icon class-name="ico28" icon-class="recharge" />-->
          <!--<span>申请充值</span>-->
        <!--</el-menu-item>-->
       <el-menu-item index="/apply/record">
         <svg-icon class-name="ico28" icon-class="record" />
         <span>充值记录</span>
       </el-menu-item>
        <el-menu-item index="/account/detail">
          <svg-icon class-name="ico28" icon-class="detail" />
          <span>账户明细</span>
        </el-menu-item>
         <el-menu-item index="/password/update">
           <svg-icon class-name="ico28" icon-class="update-pass" />
           <span>修改密码</span>
         </el-menu-item>
        <el-menu-item index="/login/log">
         <svg-icon class-name="ico28" icon-class="login" />
         <span>登录日志</span>
       </el-menu-item>
        <el-menu-item index="/operate/log">
          <svg-icon class-name="ico28" icon-class="operation" />
          <span>操作日志</span>
        </el-menu-item>
        <!--<sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path" />-->
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import variables from '@/styles/variables.scss'
import { mapGetters } from 'vuex'
export default {
  components: { },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      // if set path, the Sidebar will highlight the path you set
      // console.log('meta.activeMenu:' + meta.activeMenu)
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables () {
      return variables
    }
  }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Index.vue